import {AfterViewInit,ChangeDetectorRef,Component,Inject,OnInit, ViewChild} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import { MatInput } from '@angular/material';
import { User } from '../../models/user';
import { WizardHpBaseComponent } from '../../base/wizard/wizard-hp-base-component';
import { HpService } from '../../services/hp.service';
import { Router } from '@angular/router';

const frenchRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 de ${length}`; }
  
  length = Math.max(length, 0);
  
  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} de ${length}`;
}
export interface Archive {
  id: string;
  name: string;
  email: string;
  date_add: Date;
 }

export interface UserData {
  id: string;
  name: string;
  catalogue: string;
  date_: Date;
}

@Component({
  selector: 'app-infos-prix',
  templateUrl: './infos-prix.html',
  styleUrls: ['./infos-prix.scss']
 })
export class InfosPrixComponent  extends WizardHpBaseComponent implements OnInit {

  public dialog_data;
  archives = [];
  currentUser: User;
   @ViewChild(MatSort,{static: false}) sort: MatSort;
  @ViewChild('inputFrom',{ read: MatInput ,static: false}) inputFrom: MatInput;
  @ViewChild('inputTo',{ read: MatInput ,static: false}) inputTo: MatInput;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,  router: Router, @Inject(MAT_DIALOG_DATA) public data_dialog: any) {
    
    super(chgDetectorRef, hpService, router);
 
  }

  

  

  ngOnInit() {
    super.ngOnInit();
    this.dialog_data = this.data_dialog;
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
       
  }


}

